import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class NextPage extends Component {

    getNextPage(page){
        switch(page){
            case "TradeshowManagement":
                return {name: "Exhibit Management", url: "/services/exhibit_management"};
            case "ExhibitManagement":
                return {name: "Displays", url: "/displays/displays"};
            case "Displays":
                return {name: "Custom Fabrication", url: "/displays/custom_fabrication"};
            case "CustomFabrication":
                return {name: "Accessories", url: "/accessories"};
            case "Accessories":
                return {name: "Design", url: "/design"};
            default:
                return "";
        }
    }

    render() {
        const nextPage = this.getNextPage(this.props.page);
        return (
            <div className="next-page">
                <Link to={nextPage.url}>{nextPage.name} &gt;&gt;</Link>
            </div>
        );
    }
}

export default NextPage;


// WEBPACK FOOTER //
// ./src/components/NextPage/NextPage.js